<div class="mat-body-1 p-10 rounded m-t-0">

    <div class="contact-container rounded m-t-0">
        <strong>
            <i-tabler name="address-book" class="m-r-10 icon-18" />
            {{ 'LABEL.CONTACT_DETAILS' | translate }}
        </strong>

        <div class="address-group">

            <div class="row m-t-10">
                <div class="col-lg-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.MOBILE_LABEL' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'LABEL.MOBILE_LABEL' | translate }}"
                            [(ngModel)]="patient.contactInfo[0].contact" name="contact" #contact="ngModel"
                            pattern="^[1-9]\d{9}$" maxlength="10" minlength="10" appAllowOnlyDigits>
                      <mat-error *ngIf="contact.hasError('minlength')">
                        {{ 'REQUIRED.MINIMUM10' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!contact.hasError('minlength') && contact.hasError('pattern')">
                        {{ 'REQUIRED.ONLY_NUMBER' | translate }}
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="col-lg-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.PHONE_LABEL' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'LABEL.PHONE_LABEL' | translate }}"
                            [(ngModel)]="patient.contactInfo[0].phone" name="phone" #phone="ngModel"
                            pattern="^[1-9]\d{9}$" maxlength="10" minlength="10" appAllowOnlyDigits>
                        <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">
                            <span *ngIf="phone.errors?.['minlength']">{{ 'REQUIRED.MINIMUM10' | translate }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-3">
                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <mat-label>{{ 'LABEL.EMAIL_LABEL' | translate }}</mat-label>
                        <input type="email" matInput placeholder="{{ 'LABEL.EMAIL_LABEL' | translate }}"
                            [(ngModel)]="patient.contactInfo[0].email" name="email" #email="ngModel" email
                            pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.(com|net|org|in)$">
                        <mat-error *ngIf="email.invalid && (email.dirty || email.touched)">
                            <span *ngIf="email.errors?.['pattern'] || email.errors?.['email']">
                                {{ 'VALIDATION.EMAIL' | translate }}
                            </span>
                        </mat-error>

                    </mat-form-field>
                </div>
                <div class="col-lg-3">

                    <mat-checkbox class="justify-content-end" [color]="'primary'"
                        [(ngModel)]="patient.contactInfo[0].isDefault"></mat-checkbox>
                    {{ 'LABEL.DEFAULT_LABEL' | translate }}
                </div>
                <!-- <div class="col-lg-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Fax</mat-label>
                        <input type="text" matInput placeholder="Fax No" [(ngModel)]="patient.contactInfo[0].fax"
                            name="fax" #fax="ngModel" pattern="^[0-9]{10}$">
                        <mat-error *ngIf="fax.invalid && (fax.dirty || fax.touched)">
                            <span *ngIf="fax.errors?.['pattern']">Enter valid fax no.</span>
                        </mat-error>
                    </mat-form-field>
                </div> -->

            </div>
        </div>
    </div>
</div>